// The MFA challenge between AUTH-01 and AUTH-02. Memory only; it expires in about 5 minutes.
export interface MfaChallenge {
  mfa_token: string;
  methods: string[];
  expiresAt: number;
  redirect?: string | undefined;
}
let current: MfaChallenge | null = null;
export const mfaChallenge = {
  set(c: MfaChallenge) {
    current = c;
  },
  get(): MfaChallenge | null {
    return current && current.expiresAt > Date.now() ? current : null;
  },
  clear() {
    current = null;
  },
};
